const transform = data => {
  if (data.company && typeof(data.company) !== 'string') data.company = data.company['@id']
  return data
}

export default transform